import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ProjectCard from '../common/ProjectCard';
import PageShell, { PageHeader } from '../common/PageShell';
import { colors, motion, space, type } from '../../styles/tokens';

const ProjectsPage = () => {
  const [shelfHovered, setShelfHovered] = useState(false);

  return (
    <PageShell>
      <PageHeader title="Projects" subtitle="Products, and the thinking behind them" flourish="✦" />

      <ProjectCard
        title="Curriculum Mapping Platform"
        tech="LLM APIs • Python • FastAPI • React"
        description="An internal AI product for the Yale SOM Dean's Office that analyzes up to 80 syllabi at once and returns evidence-linked answers showing where a theme is taught across courses. Owned end-to-end — scoping, UX, engineering, and rollout. The interesting problem was not extraction; it was deciding what counts as evidence, how much judgment to give the model, and where the human expert stays in the loop. Approved internally and moving through Yale Data Governance review."
        caseStudyId="curriculum-mapping"
      />

      <ProjectCard
        title="Solara"
        tech="SwiftUI • Supabase • APIs"
        description="A personalized consumer iOS app built end-to-end — product strategy, UX, onboarding, monetization, notifications, widgets, and the subscription experience. Three of the first ten private-beta users converted to paid while preparing for public App Store launch and testing organic acquisition through short-form content."
        showLink={true}
        link="https://www.helvetstudios.com/solara"
        caseStudyId="solara"
      />

      <ProjectCard
        title="Faculty Research-Impact Platform"
        tech="Python • Google Scholar • Reporting"
        description={`An internal tool for the SOM Dean's Office that matches faculty to their Google Scholar profiles, aggregates publication and citation metrics, flags profile issues, and generates spreadsheet and PDF reports for school-wide analysis.\n\nAfter Yale School of the Environment reviewed it, they brought me on to adapt the product to their own faculty-data workflows.`}
      />

      <ProjectCard
        title="FormFriend"
        tech="SwiftUI • Spring Boot • AWS Textract • OpenAI • PostgreSQL"
        description="A multilingual legal-document guidance app built at Yale YHack to help immigrants understand and complete legal paperwork more safely. OCR and LLM analysis turn dense PDFs into guided, step-by-step workflows with coordinate-aware highlighting, in the user's chosen language. Selected as a YHack finalist."
        showLink={true}
        link="https://www.formfriend.xyz/"
      />

      <ProjectCard
        title="KYMY"
        tech="React Native • Tailwind • Expo"
        description="A mobile app designed to help senior citizens strengthen memory and cognition through engaging brain exercises and accessible game-like interactions. Won 3rd place in the Congressional App Challenge."
        showLink={true}
        link="https://github.com/YangaB7/KYMY"
      />

      <div
        style={{
          marginTop: space[2],
          paddingTop: space[3],
          borderTop: `1px solid ${colors.hairline}`
        }}
      >
        <p style={{ ...type.body, color: colors.muted }}>
          Not everything ships. I write up the ones I stopped building too —{' '}
          <Link
            to="/case-studies"
            style={{
              ...type.link,
              fontSize: '15px',
              color: shelfHovered ? colors.inkStrong : colors.sageDeep,
              transition: `color ${motion.fast} ease`
            }}
            onMouseEnter={() => setShelfHovered(true)}
            onMouseLeave={() => setShelfHovered(false)}
          >
            read the post-mortems{' '}
            <span
              style={{
                display: 'inline-block',
                transition: `transform ${motion.fast} ease`,
                transform: shelfHovered ? 'translateX(3px)' : 'translateX(0)'
              }}
            >
              →
            </span>
          </Link>
        </p>
      </div>
    </PageShell>
  );
};

export default ProjectsPage;
